import { contactsQueryOptions } from '@/api/queries/conversations';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

export function useContactFilter() {
  const [searchTerm, setSearchTerm] = useState('');

  const { data: contacts = [], isLoading } = useQuery(contactsQueryOptions());

  const filteredContacts = useMemo(() => {
    let orderedContacts = contacts;

    if (searchTerm.trim()) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      orderedContacts = contacts.filter(
        contact =>
          contact.name.toLowerCase().includes(lowerSearchTerm) ||
          contact.email?.toLowerCase().includes(lowerSearchTerm)
      );
    }

    return orderedContacts.sort((a, b) => a.name.localeCompare(b.name));
  }, [contacts, searchTerm]);

  const clearSearch = () => {
    setSearchTerm('');
  };

  return {
    filteredContacts,
    searchTerm,
    setSearchTerm,
    clearSearch,
    isLoading,
  };
}
